import { computed } from 'mobx';
import { ObservableList } from '../core/obvservable';

/**
 * AsyncRequestsList
 */
export class AsyncRequestsList extends ObservableList<Promise<any>> {

    /**
     * Class constructor
     */
    public constructor() {
        super([], { deep: false });
    }

    /**
     * Has pending requests
     */
    @computed public get hasPendingRequests() {
        return this.data.length > 0;
    }

    /**
     * Add async request
     * @param promise 
     */
    public add<T = any, P extends Promise<T> = Promise<T>>(promise: P): P {
        this.push(promise);

        promise
            .then(data => {
                this.remove(promise);
            })
            .catch(err => {
                this.remove(promise);
            });

        return promise;
    }    
}